import { lazy, Suspense } from 'react'
import { createFileRoute } from '@tanstack/react-router'
import { Loader } from '@/shared/ui/loader'

const WarehouseContainersPage = lazy(
  () => import('@/pages/warehouse-containers/ui/index'),
)

export const Route = createFileRoute('/_protected/warehouse/containers')({
  component: () => (
    <Suspense fallback={<Loader />}>
      <WarehouseContainersPage />
    </Suspense>
  ),
})
